import { Box, Chip } from '@mui/material';

import {
  BoynerOrderStatus,
  boynerOrderStatusDescriptionMap,
  boynerOrderStatusNameMap,
} from '../../../interfaces/Boyner/BoynerOrderStatus';

interface BoynerStatusCellProps {
  status: BoynerOrderStatus;
}

export const BoynerStatusCell = (props: BoynerStatusCellProps) => {
  const getColor = () => {
    switch (props.status) {
      case BoynerOrderStatus.CREATED:
        return 'success';
      default:
        return 'error';
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={boynerOrderStatusNameMap[props.status]}
      />

      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={boynerOrderStatusDescriptionMap[props.status]}
      />
    </Box>
  );
};
